<template>
  <div>
    <input
      :type="type"
      :id="id"
      :name="name"
      :value="value"
      :min="min"
      class="c-input-text"
      :class="{
        'c-input-text--error': error,
        'c-input-text--has_icon': hasIcon,
        'c-input-text--has_suffix': hasSuffix
      }"
      :disabled="disabled"
      :error="error"
      :placeholder="placeholder"
      :maxlength="maxlength"
      @input="updateValue"
      @focus="focus"
      @blur="blur"
    />
    <span v-if="$slots.lastLabel">
      <slot name="lastLabel"></slot>
    </span>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';


@Options({
  emits: ["input", "focus", "blur"],
  props: {
    type: { type: String, required: true },
    id: String,
    name: { type: String, required: true },
    value: { type: String, required: true },
    error: String,
    placeholder: String,
    hasIcon: String,
    hasSuffix: String,
    min: Number,
    disabled: { type: Boolean, default: false },
    maxlength: Number
  }
})
export default class InputText extends Vue {
  type!: string;
  id!: string;
  name!: string;
  value!: string;
  error!: string;
  placeholder!: string;
  hasIcon!: string;
  hasSuffix!: string;
  min!: number;
  disabled!: boolean;
  maxlength!: number;

  updateValue(e: any) {
    this.$emit("input", e.target.value);
  }

  focus(e: any) {
    this.$emit("focus", e);
  }

  blur(e: any) {
    this.$emit("blur", e);
  }
}
</script>

<style lang="scss" scoped>
.c-input-text {
  font-size: rem(14);
  line-height: normal;
  width: 100%;
  border: px(1) solid $common-gray-border;
  border-radius: px(4);
  padding: rem(10) rem(12) rem(11) rem(12);
  display: block;

  &::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }

  &--error {
    border-color: $error;
  }

  &--has_icon {
    padding-right: px(48+12);
  }

  &--has_suffix {
    padding-right: px(24+12);
  }

  &::placeholder {
    color: $common-gray300;
  }

  &:focus {
    border-color: $common-black;
  }
}
</style>
